import { lazy } from "react";
import AuthPages from "../pages/auth/AuthPages";
import KycPages from "../pages/kyc/KycPages";
import Referral from "../pages/referral/ReferralEarnPage";
import TransactionPage from "../pages/transaction/TransactionPage";
import NotificationsPage from "@/pages/notifications/Notifications.page";
import { ProtectedRoute } from "@/components/common/ProtectedRoute";
import SidebarLayout from "@/pages/admin_dashboard/admindashboard";
import MutualFundPage from "@/pages/mutulfund/MutualFundPage";
import SchemeDetailsPage from "@/components/features/mutual-funds/SchemeDetailsPage";
import Dashboard from "@/pages/dashboard";
import UserApprovalRequests from "@/pages/order/UserApprovalRequests";

// Import the LearningCenter component
const LearningCenter = lazy(() =>
  import("../pages/learning/LearningCenter.jsx")
);

// Lazy load components for better performance
const Home = lazy(() => import("../pages/static/Homepage"));
const About = lazy(() => import("../pages/static/Aboutpage"));
const Services = lazy(() => import("../pages/static/Services"));
const Projects = lazy(() => import("../pages/static/Projects"));
const Blog = lazy(() => import("../pages/blog/Blog"));
const BlogDetails = lazy(() => import("../components/static/blog/BlogDetails"));
const Team = lazy(() => import("../pages/static/Team"));
const Testimonials = lazy(() => import("../pages/static/Testimonials"));
const Faqs = lazy(() => import("../pages/static/Faqs"));
const Contact = lazy(() => import("../pages/static/Contactpage"));
const NotFound = lazy(() => import("../pages/static/NotFound"));
const Screener = lazy(() => import("../components/features/Screener/Screener"));
const Screenerlist = lazy(() =>
  import("../components/features/Screener/screenerlist")
);
const Company_info = lazy(() => import("../pages/company_info/company_info"));
const Watchlist = lazy(() =>
  import("../components/features/Watchlist/watchlist")
);
const OwnScreenerPage = lazy(() =>
  import("../components/features/Screener/OwnScreener")
);
const OwnWatchlistPage = lazy(() =>
  import("../components/features/Watchlist/ownWatchlist")
);

const BondListingsPage = lazy(() => import("../pages/aspero/BondListingsPage"));
const MyBondInvestments = lazy(() => import("../pages/aspero/MyBondInvestments"));

const PortfolioPage = lazy(() =>
  import("../components/features/Portfolio/PortfolioPage")
);
const HoldingsPage = lazy(() =>
  import("../components/features/Portfolio/HoldingsPage")
);
const InvestmentRecommendations = lazy(() =>
  import("../components/features/Portfolio/InvestmentRecommendationsPage")
);
const PersonalizedPortfolioSolution = lazy(() =>
  import("../components/features/Portfolio/PersonalizedPortfolioSolution")
);
const AreaChart = lazy(() =>
  import("../components/static/Admindashboard/AreaChart")
);
const PieChart = lazy(() =>
  import("../components/static/Admindashboard/PieChart")
);
const Alluser = lazy(() =>
  import("../components/static/Admindashboard/Alluser")
);
const KycStatus = lazy(() =>
  import("../components/static/Admindashboard/KycStatus")
);
const UserWatchlists = lazy(() =>
  import("../components/static/Admindashboard/UserWatchlists")
);
const UserPortfolios = lazy(() =>
  import("../components/static/Admindashboard/UserPortfolios")
);
const AdminUserDetails = lazy(() =>
  import("../components/static/Admindashboard/AdminUserDetails")
);
const ProductList = lazy(() =>
  import("../components/static/Product/ProductList")
);
const ProductHistory = lazy(() =>
  import("../components/static/Product/ProductHistory")
);
const ProductChart = lazy(() =>
  import("../components/static/Product/ProductChart")
);
const Posts = lazy(() => import("../components/static/Adminblog/Posts"));
const Categories = lazy(() =>
  import("../components/static/Adminblog/Categories")
);
const Blogtags = lazy(() => import("../components/static/Adminblog/Blogtags"));
const Comments = lazy(() => import("../components/static/Adminblog/Comments"));
const Blogstats = lazy(() =>
  import("../components/static/Adminblog/Blogstats")
);
const AdminProfile = lazy(() =>
  import("../components/static/Admindashboard/AdminProfile")
);
const UserKycView = lazy(() =>
  import("../components/static/Admindashboard/UserKycView")
);
const ViewEditScreener = lazy(() =>
  import("../components/features/Screener/view-edit_savedScreeners")
);
const PortfolioDashboard = lazy(() =>
  import("../components/features/Portfolio/PortfolioAnalysis")
);
const RebalancePortfolio = lazy(() =>
  import("../components/features/Portfolio/RebalancePortfolio")
);
const Experts = lazy(() =>
  import("../components/features/Appointments/Experts")
);
const BookAppointmentPage = lazy(() =>
  import("../components/features/Appointments/BookAppointmentPage")
);
const ownAppointments = lazy(() =>
  import("../components/features/Appointments/ownAppointments")
);
const UserSupport = lazy(() => import("../components/features/Support/Support.jsx"));
const ExpertDashboard = lazy(() =>
  import("../pages/expert_dashboard/expert_dashboard")
);
const OrderHistory = lazy(() =>
  import("../components/features/Wallet/OrderHistory")
);
const PrivacyPolicy = lazy(() => import("../pages/static/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("../pages/static/TermsOfUse"));
const RefundCancellationPolicy = lazy(() => import("../pages/static/RefundCancellationPolicy"));
const ShippingDeliveryPolicy = lazy(() => import("../pages/static/ShippingDeliveryPolicy"));

export const routes = [
  { path: "/", element: Home, name: "Home" },
  { path: "/about", element: About, name: "About" },
  { path: "/services", element: Services, name: "Services" },
  { path: "/projects", element: Projects, name: "Projects" },
  { path: "/blog/*", element: Blog, name: "Blog" },
  { path: "/blog/details/:slug", element: BlogDetails, name: "Blog Details" },
  {
    path: "/mutual-funds",
    element: MutualFundPage,
    name: "Mutual Fund",
  },
  {
    path: "/mutual-funds/:schemeCode",
    element: SchemeDetailsPage,
    name: "Scheme Details",
  },
  {
    path: "/team",
    element: Team,
    name: "Team",
  },
  {
    path: "/testimonials",
    element: Testimonials,
    name: "Testimonials",
  },
  {
    path: "/faqs",
    element: Faqs,
    name: "Faqs",
  },
  {
    path: "/referral",
    element: Referral,
    name: "Referral",
  },
  {
    path: "/orders",
    element: UserApprovalRequests,
    name: "Order Request",
  },
  {
    path: "/learning-center",
    element: LearningCenter,
    name: "Learning Center",
  },
  {
    path: "/appointments",
    element: Experts,
    name: "Experts",
  },
  {
    path: "/book/:expertId",
    element: BookAppointmentPage,
    name: "BookAppointmentPage",
  },
  {
    path: "/contact",
    element: Contact,
    name: "Contact",
  },
  {
    path: "/privacy-policy",
    element: PrivacyPolicy,
    name: "Privacy Policy",
  },
  {
    path: "/terms-of-use",
    element: TermsOfUse,
    name: "Terms of Use",
  },
  {
    path: "/refund-cancellation-policy",
    element: RefundCancellationPolicy,
    name: "Refund & Cancellation Policy",
  },
  {
    path: "/shipping-delivery-policy",
    element: ShippingDeliveryPolicy,
    name: "Shipping & Delivery Policy",
  },
  {
    path: "/Signin-Signup",
    element: AuthPages,
    name: "Signin/Signup",
  },
  {
    path: "/signup",
    element: AuthPages,
    name: "Signup",
  },
  {
    path: "/profile/kyc",
    element: KycPages,
    name: "kyc",
  },
  {
    path: "/notifications",
    element: NotificationsPage,
    name: "notification",
  },
  {
    path: "*",
    element: NotFound,
    name: "Not Found",
  },
  {
    path: "/screener",
    element: Screener,
    name: "screener",
  },
  {
    path: "/screenerlist",
    element: Screenerlist,
    name: "screenerlist",
  },
  {
    path: "/company_info/:uniqueTitle",
    element: Company_info,
    name: "Company Info",
  },
  {
    path: "/watchlist/:unique-title",
    element: Watchlist,
    name: "Watchlist",
  },
  {
    path: "/myScreener",
    element: OwnScreenerPage,
    name: "Own Screener",
  },
  {
    path: "/myWatchlist",
    element: OwnWatchlistPage,
    name: "Own Watchlist",
  },
  {
    path: "/profile/kyc/basic-info",
    element: KycPages,
    name: "KYC Basic Info",
  },
  {
    path: "/profile/kyc/demat-details",
    element: KycPages,
    name: "KYC Demat Details",
  },
  {
    path: "/profile/kyc/bank-details",
    element: KycPages,
    name: "KYC Bank Details",
  },
  {
    path: "/profile/kyc/documents",
    element: KycPages,
    name: "KYC Documents",
  },
  {
    path: "/profile/kyc/review",
    element: KycPages,
    name: "KYC Review",
  },
  {
    path: "/profile/kyc/status",
    element: KycPages,
    name: "KYC Status",
  },
  {
    path: "/portfolio",
    element: PortfolioPage,
    name: "Portfolio",
  },
  {
    path: "/portfolio/:portfolioId",
    element: HoldingsPage,
    name: "Holdings",
  },
  {
    path: "/portfolio/:portfolio-id/investment-recommendations",
    element: InvestmentRecommendations,
    name: "Investment Recommendations",
  },
  {
    path: "/portfolio/:portfolio-id/portfolio-solution",
    element: PersonalizedPortfolioSolution,
    name: "Portfolio Solution",
  },
  {
    path: "/wallet",
    element: TransactionPage,
    name: "Transaction",
  },
  {
    path: "/orderHistory",
    element: OrderHistory,
    name: "Order History",
  },
  {
    path: "/admindashboard/*",
    element: (props) => (
      <ProtectedRoute requiredRole="admin">
        <SidebarLayout {...props} />
      </ProtectedRoute>
    ),
    name: "Admin Dashboard",
  },
  {
    path: "/admin/areachart",
    element: AreaChart,
    name: "AreaChart",
  },
  {
    path: "/piechart",
    element: PieChart,
    name: "PieChart",
  },
  {
    path: "/admin/alluser",
    element: Alluser,
    name: "Alluser",
  },
  {
    path: "/admin/KycStatus",
    element: KycStatus,
    name: "KycStatus",
  },
  {
    path: "/UserWatchlists",
    element: UserWatchlists,
    name: "UserWatchlists",
  },
  {
    path: "/UserPortfolios",
    element: UserPortfolios,
    name: "UserPortfolios",
  },
  {
    path: "/AdminUserDetails",
    element: AdminUserDetails,
    name: "AdminUserDetails",
  },
  {
    path: "/ProductList",
    element: ProductList,
    name: "ProductList",
  },
  {
    path: "/ProductHistory",
    element: ProductHistory,
    name: "ProductHistory",
  },
  {
    path: "/ProductChart",
    element: ProductChart,
    name: "ProductChart",
  },
  {
    path: "/Posts",
    element: Posts,
    name: "Posts",
  },
  {
    path: "/Categories",
    element: Categories,
    name: "Categories",
  },
  {
    path: "/Blogtags",
    element: Blogtags,
    name: "Blogtags",
  },
  {
    path: "/Comments",
    element: Comments,
    name: "Comments",
  },
  {
    path: "/Blogstats",
    element: Blogstats,
    name: "Blogstats",
  },
  {
    path: "/AdminProfile",
    element: AdminProfile,
    name: "AdminProfile",
  },
  {
    path: "/UserKycView",
    element: UserKycView,
    name: "UserKycView",
  },
  {
    path: "/screenerView",
    element: ViewEditScreener,
    name: "ViewEditScreener",
  },
  {
    path: "/portfolio/:portfolioId/analytics",
    element: PortfolioDashboard,
    name: "PortfolioDashboard",
  },
  {
    path: "/portfolio/:portfolioId/rebalance",
    element: RebalancePortfolio,
    name: "RebalancePortfolio",
  },
  {
    path: "/myappointments",
    element: ownAppointments,
    name: "myAppointments",
  },
  {
    path: "/support",
    element: UserSupport,
    name: "UserSupport",
  },
  {
    path: "/dashboard",
    element: (props) => (
      <ProtectedRoute requiredRole="user">
        <Dashboard {...props} />
      </ProtectedRoute>
    ),
    name: "Unlisted Shares",
  },
  {
    path: "/expertdashboard",
    element: ExpertDashboard,
    name: "ExpertDashboard",
  },
  {
    path: "/bonds-listing",
    element: BondListingsPage,
    name: "Bonds",
  },
  {
    path: "/bonds/my-investments",
    element: MyBondInvestments,
    name: "My Bond Investments",
  },
];
